import * as React from 'react';
import { ModalContext } from './ModalProvider';

export const useModalContext = () => {
  const context = React.useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModalContext must be used within a ModalProvider');
  }
  return context;
};

export default useModalContext;
